import React from "react";

const STYLE = {
  display: "block",
  width: "100%",
  height: "100%",
  alignSelf: "stretch",
};

export const DE = () => (
  <svg viewBox="0 0 5 3" aria-hidden="true" style={STYLE}>
    <rect width="5" height="1" fill="#000" />
    <rect y="1" width="5" height="1" fill="#D00" />
    <rect y="2" width="5" height="1" fill="#FFCE00" />
  </svg>
);

export const ES = () => (
  <svg viewBox="0 0 3 2" aria-hidden="true" style={STYLE}>
    <rect width="3" height="2" fill="#AA151B" />
    <rect y="0.5" width="3" height="1" fill="#F1BF00" />
  </svg>
);

export const FR = () => (
  <svg viewBox="0 0 3 2" aria-hidden="true" style={STYLE}>
    <rect width="3" height="2" fill="#ED2939" />
    <rect width="2" height="2" fill="#fff" />
    <rect width="1" height="2" fill="#002395" />
  </svg>
);

export const IT = () => (
  <svg viewBox="0 0 3 2" aria-hidden="true" style={STYLE}>
    <rect width="3" height="2" fill="#CE2B37" />
    <rect width="2" height="2" fill="#fff" />
    <rect width="1" height="2" fill="#009246" />
  </svg>
);

export const NL = () => (
  <svg viewBox="0 0 3 2" aria-hidden="true" style={STYLE}>
    <rect width="3" height="2" fill="#21468B" />
    <rect width="3" height="1.333" fill="#fff" />
    <rect width="3" height="0.667" fill="#AE1C28" />
  </svg>
);

export const BR = () => (
  <svg viewBox="0 0 20 14" aria-hidden="true" style={STYLE}>
    <rect width="20" height="14" fill="#009C3B" />
    <polygon points="10,1 19,7 10,13 1,7" fill="#FFDF00" />
    <circle cx="10" cy="7" r="3.2" fill="#002776" />
    <path d="M6.8,5.6 Q10,3.8 13.2,5.6" stroke="#fff" strokeWidth="0.55" fill="none" />
  </svg>
);

export const TR = () => (
  <svg viewBox="0 0 30 20" aria-hidden="true" style={STYLE}>
    <rect width="30" height="20" fill="#E30A17" />
    <circle cx="11" cy="10" r="5.5" fill="#fff" />
    <circle cx="12.5" cy="10" r="4.4" fill="#E30A17" />
    <polygon
      points="20,7.2 20.66,9.09 22.66,9.14 21.07,10.35 21.65,12.27 20,11.12 18.35,12.27 18.94,10.35 17.34,9.14 19.34,9.09"
      fill="#fff"
    />
  </svg>
);

export const CN = () => (
  <svg viewBox="0 0 30 20" aria-hidden="true" style={STYLE}>
    <rect width="30" height="20" fill="#DE2910" />
    <polygon
      points="7.5,4 8.62,7.22 12,7.22 9.32,9.14 10.43,12.36 7.5,10.44 4.57,12.36 5.68,9.14 3,7.22 6.38,7.22"
      fill="#FFDE00"
    />
    <polygon
      points="13,1.8 13.42,3.08 14.74,3.08 13.7,3.84 14.12,5.12 13,4.36 11.88,5.12 12.3,3.84 11.26,3.08 12.58,3.08"
      fill="#FFDE00"
    />
    <polygon
      points="15,4.3 15.42,5.58 16.74,5.58 15.7,6.34 16.12,7.62 15,6.86 13.88,7.62 14.3,6.34 13.26,5.58 14.58,5.58"
      fill="#FFDE00"
    />
    <polygon
      points="15,8.3 15.42,9.58 16.74,9.58 15.7,10.34 16.12,11.62 15,10.86 13.88,11.62 14.3,10.34 13.26,9.58 14.58,9.58"
      fill="#FFDE00"
    />
    <polygon
      points="13,10.8 13.42,12.08 14.74,12.08 13.7,12.84 14.12,14.12 13,13.36 11.88,14.12 12.3,12.84 11.26,12.08 12.58,12.08"
      fill="#FFDE00"
    />
  </svg>
);

export const JP = () => (
  <svg viewBox="0 0 3 2" aria-hidden="true" style={STYLE}>
    <rect width="3" height="2" fill="#fff" />
    <circle cx="1.5" cy="1" r="0.6" fill="#BC002D" />
    <rect width="3" height="2" fill="none" stroke="#d1d5db" strokeWidth="0.06" />
  </svg>
);

export const Globe = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="#94a3b8"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    style={STYLE}
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
);
